import { render, staticRenderFns } from "./AddReceipt.vue?vue&type=template&id=2ddd43ac&scoped=true&"
import script from "./AddReceipt.vue?vue&type=script&lang=js&"
export * from "./AddReceipt.vue?vue&type=script&lang=js&"
import style0 from "./AddReceipt.vue?vue&type=style&index=0&id=2ddd43ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd43ac",
  null
  
)

export default component.exports